import { render } from "./WoTEventsEditView.vue?vue&type=template&id=3c0f4a0a"
import script from "./WoTEventsEditView.vue?vue&type=script&lang=js"
export * from "./WoTEventsEditView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__